import React, { Fragment, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { parse } from 'query-string';
import { Provider } from 'react-redux';
import { Base64 } from 'js-base64';
import { YMInitializer } from 'react-yandex-metrika';
import * as Sentry from '@sentry/browser';
// import { loadReCaptcha } from 'react-recaptcha-v3';
import AppRouter from './routes/AppRouter';
import configureStore from './store/configureStore';
import { startGetProfile } from './actions/webmaster';
import { openModal } from './actions/modals';
import { checkForRef, checkForRedirectUrl } from './utils/utils';
import IntlProvider from './hoc/IntlProvider';
import { Cookies, isCabinet } from './utils/utils';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import { startSetAuthSettings } from './actions/app';
import smoothscroll from 'smoothscroll-polyfill';
import ReactPixel from 'react-facebook-pixel';

smoothscroll.polyfill();

// const loadReCaptcha = (siteKey, callback) => {
//   const script = document.createElement('script');

//   if (!script.onload && callback) {
//     script.onload = callback;
//   }

//   script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;

//   document.body.appendChild(script);
// };

const store = configureStore();

store.dispatch(startGetProfile());

const intlStore = store.getState().intl;

if (PRODUCTION) {
  Sentry.init({
    dsn: 'https://bd8c60ef1436409fb1b12cabc2e7657a@sentry.offerrum.com/4',
  });
}

checkForRef();
checkForRedirectUrl();

// полифил Intl API
const ensureIntlSupport = () => {
  if (window.Intl) return Promise.resolve();
  return new Promise((resolve) => {
    resolve(require('intl'));
  }).then(() =>
    Promise.all([require(`intl/locale-data/jsonp/ru.js`), require(`intl/locale-data/jsonp/en.js`)]),
  );
};

const { locale, defaultLocale, messages } = intlStore;
const App = () => {
  useEffect(() => {
    // параметры ставятся в куку чтобы бек детектил с какого ресурса к нам пришел юзер (например для начисления бонусов)
    const currentParams = parse(window.location.search);
    const referer = document.referrer;

    try {
      if (Object.keys(currentParams).length > 0 || referer) {
        let prevParams = {};
        const getParamsCookie = Cookies.get('_adSource');

        if (getParamsCookie) {
          prevParams = JSON.parse(Base64.decode(decodeURIComponent(getParamsCookie))).get;
        }

        const get_params = { get: { ...prevParams, ...currentParams } };

        if (referer) {
          get_params.referer = referer;
        }
        const baseString = encodeURIComponent(Base64.encode(JSON.stringify(get_params)));

        const date = new Date();
        date.setTime(date.getTime() + 14 * 24 * 60 * 60 * 1000);

        document.cookie = `_adSource=${baseString}; expires=${date.toUTCString()}; domain=.${
          window.location.hostname
        }; path=/`;
      }
    } catch (error) {
      console.log(error);
    }

    //  store.dispatch(startSetAuthSettings()).then(({ settings }) => {
    //    if (settings) {
    //      const { recaptcha } = settings;
    //      if (recaptcha) {
    //        const { v3 } = recaptcha;
    //        loadReCaptcha(v3, () => store.dispatch({ type: 'RECAPTCHA_LOADING_SUCCESS' }));
    //      }
    //    }
    //  });
    store.dispatch(startSetAuthSettings());

    // Initialize Facebook Pixel
    ReactPixel.init('772059600013281');
    // Trigger page view event
    ReactPixel.pageView();
  });
  return (
    <Provider store={store}>
      <Fragment>
        <IntlProvider
          key={!isCabinet() ? locale : 'ru'}
          locale={!isCabinet() ? locale : 'ru'}
          defaultLocale={!isCabinet() ? defaultLocale : 'ru'}
          messages={messages}
          textComponent={Fragment}
        >
          <ErrorBoundary>
            <AppRouter />
          </ErrorBoundary>
        </IntlProvider>
        <YMInitializer
          accounts={[53344675]}
          options={{
            clickmap: true,
            trackLinks: true,
            accurateTrackBounce: true,
          }}
          version="2"
        />
      </Fragment>
    </Provider>
  );
};

ensureIntlSupport().then(() => {
  ReactDOM.render(<App />, document.getElementById('app'));

  // TODO: Вынести всю эту фигню про телеграм в отдельную функцию
  const isTelegramPopupShowing =
    !Cookies.get('_offerrum_tg_subscriber_') &&
    !Cookies.get('_offerrum_tg_popup_shown_') &&
    window.location.pathname !== '/publisher/sign_in' &&
    window.location.pathname !== '/publisher/sign_up' &&
    window.location.pathname !== '/ip';

  // if (isTelegramPopupShowing) {
  //   let popupTimerId = null;
  //   // на мобиле 60 секунд, на планшетах и выше 30
  //   const popupTimeout = window.innerWidth > 460 ? 30 * 1000 : 60 * 1000;

  //   const telegramModalProps = {
  //     shouldCloseOnOverlayClick: false,
  //     shouldCloseOnEsc: false,
  //     className: 'modal-slide-in',
  //     closeTimeoutMS: 300,
  //   };

  //   const windowMouseLeaveHandler = e => {
  //     if (e.pageY - window.pageYOffset < 1) {
  //       openPopup();
  //     }
  //   };

  //   window.addEventListener('mouseout', windowMouseLeaveHandler);

  //   const openPopup = () => {
  //     stopPopupTimer();
  //     window.removeEventListener('mouseout', windowMouseLeaveHandler);
  //     store.dispatch(
  //       openModal({
  //         modalProps: telegramModalProps,
  //         modalType: telegramModalType,
  //       }),
  //     );
  //   };

  //   const telegramModalType = 'telegramSubscribe';

  //   const startPopupTimer = () => {
  //     if (!popupTimerId) {
  //       popupTimerId = setTimeout(openPopup, popupTimeout);
  //     }
  //   };

  //   const stopPopupTimer = () => {
  //     clearInterval(popupTimerId);
  //   };

  //   startPopupTimer();
  // }

  // const getResponseFromLocation = () => {
  //   const { hash, search } = window.location;
  //   let params = parse(search);

  //   if (!params.code && !params.error && hash !== '#_=_') {
  //     params = parse(hash);
  //   }

  //   if (params.access_token || params.code) {
  //     store.dispatch(
  //       openModal({
  //         modalProps: {},
  //         modalType: 'affiliateSignIn',
  //       }),
  //     );
  //   }
  // };

  // getResponseFromLocation();
});
